const STORE_KEY = 'CONSTRUCTOR'

export const FETCH_TEST_CONSTRUCTOR = `${STORE_KEY}/FETCH_TEST_CONSTRUCTOR`

export const IS_TEST_CONSTRUCTOR_WITH_TITLE_LINKS = `${STORE_KEY}/IS_TEST_CONSTRUCTOR_WITH_TITLE_LINKS`

export const SET_TEST_CONSTRUCTOR_PARTS = `${STORE_KEY}/SET_TEST_CONSTRUCTOR_PARTS`
